<div class="container">
  <div class="row" style="padding-top: 30px;">
    <div class="menu col-lg-1">
      <div *ngIf="edition">
        <a class="btn btn-outline-warning" #tooltip="matTooltip" matTooltip="Enregistrer" matTooltipPosition="left">
          <mat-icon type="submit" (click)="enregistrer()">save</mat-icon> </a><br />
        <a class="btn btn-outline-warning" #tooltip="matTooltip" matTooltip="Rafraichir" matTooltipPosition="left">
          <mat-icon (click)="rafraichir()">refresh</mat-icon> </a><br />
        <a class="btn btn-outline-warning" #tooltip="matTooltip" matTooltip="Annuler" matTooltipPosition="left">
          <mat-icon (click)="annuler()">close</mat-icon> </a><br />
      </div>
      <div *ngIf="lecture">
        <a class="btn btn-outline-warning" #tooltip="matTooltip" matTooltip="Modifier" matTooltipPosition="left">
          <mat-icon (click)="modeEdition()">edit</mat-icon> </a><br />
        <a class="btn btn-danger" #tooltip="matTooltip" matTooltip="Supprimer" matTooltipPosition="left">
          <mat-icon (click)="suppressiondemasse()">delete</mat-icon> </a><br />
      </div>
    </div>
    <div class="col-lg-11" *ngIf="edition">
      <ng-container>
        <div class="row">
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Nom du Menu</strong></label></ng-container><br />
            <div>
              <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                <input [(ngModel)]="menuObj.text" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Ordre du Menu</strong></label></ng-container><br />
            <div>
              <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                <input type="number" [(ngModel)]="menuObj.order" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-6">
            <label><strong>Fils du menu</strong></label><br />
            <ng-container>
              <div>
                <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                  <mat-select  [(ngModel)]="menuObj.children " multiple
                    [compareWith]="compareValeurs" [compareWith]="compareValeurs">
                    <mat-option [value]="null">Veuillez sélectionner</mat-option>
                    <mat-option *ngFor="let item of selectedFils" [value]="item">
                      {{item.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Parent du Menu</strong></label></ng-container><br />
            <div>
              <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                <input matInput (ngModelChange)="autocompleteSearchMenu($event)" [matAutocomplete]="auto"
                  [formControl]="searchMenuCtrl" />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [panelWidth]="570">
                  <ng-container>
                    <mat-option *ngFor="let menu of filteredMenu" (click)="onAutocompleteOptionMenuSelected(menu)">
                      <ng-container>
                        <div *ngIf="menu">
                          {{ menu.text }}
                        </div>
                      </ng-container>
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Entite du Menu</strong></label></ng-container><br />
            <div>
              <mat-form-field appearance="outline" style="font-size: 10px; width: 100%">
                <input matInput type="text" (ngModelChange)="autocompleteSearchDocumentInfo($event)" [matAutocomplete]="autodocument"
                  [formControl]="searchDocumentInfoCtrl" />
                <mat-autocomplete autoActiveFirstOption #autodocument="matAutocomplete" [panelWidth]="570">
                  <ng-container>
                    <mat-option *ngFor="let document of filteredDocumentInfo" (click)="onAutocompleteOptionDocumentInfoSelected(document)">
                      <ng-container>
                        <div *ngIf="document">
                          {{ document.documentName }}
                        </div>
                      </ng-container>
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- Existing code -->
            
            <!-- New panel for radio buttons -->
            <div class="row">
              <div class="col-lg-12">
                <div style="margin-top: 10px;margin-bottom: 10px;"><strong>Selectioner un Icon:</strong></div>
                
                  <!-- Iterate over icons array -->
                  <span class="col-lg-3" *ngFor="let icon of icons" style="margin: 10px;padding: 10px;">
                   
                      <!-- Display mat-icon -->
                      <span style="margin-right: 5px;"> <mat-icon mat-list-icon  [svgIcon]="icon"></mat-icon></span> 
                      <!-- Radio button -->
                      <input type="radio" name="icon" [value]="icon" [(ngModel)]="menuObj.icon">
                      <span class="checkmark"></span>
                   
                  </span>
                  <!-- Option for "pas un icon" -->
                  <label class="radio-container">Pas un icon
                    <input type="radio" name="icon" value="pas un icon" [(ngModel)]="menuObj.icon">
                    <span class="checkmark"></span>
                  </label>
                
              </div>
            </div>
          </div>
          
        </div>

      </ng-container>

    </div>
    <div class="col-lg-11" *ngIf="lecture">
      <ng-container>
        <div class="row">
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Nom du Menu</strong></label></ng-container><br />
            <div>
              <ng-container *ngIf="!editMode">
                <div>
                  {{ menuObj.text }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Ordre du Menu</strong></label></ng-container><br />
            <div>
              <ng-container *ngIf="!editMode">
                <div>
                  {{ menuObj.order }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-6">
            <label><strong>Fils du menu</strong></label><br />
             <ng-container *ngIf="!editMode">
              <div *ngFor="let value of menuObj.children">{{ value?.text }}</div>
            </ng-container> 
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Parent du Menu</strong></label></ng-container><br />
            
              <ng-container *ngIf="!editMode">
                <!-- <div *ngIf="config.displayMode !== 'link'">
                  {{ value?.[config.searchableFields[0]
                  ] }}
                </div> -->
                <a
                  class="clickable-label"
                  (click)="ouvrirOnglet(menuObj?.parentId)"
                >
                  {{ menuObj?.parentId }}
                </a>
              </ng-container>
          
          </div>
          <div class="col-lg-6">
            <ng-container>
              <label><strong>Entite du Menu</strong></label></ng-container><br />
            <div>
              <ng-container *ngIf="!editMode">
                <!-- <div *ngIf="config.displayMode !== 'link'">
                  {{ value?.[config.searchableFields[0]
                  ] }}
                </div> -->
                <div
                  class="clickable-label"
                  (click)="ouvrirOnglet(menuObj?.entityName)"
                >
                  {{ menuObj?.entityName }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- Existing code -->
            
            <!-- New panel for radio buttons -->
            <div class="row">
              <div class="col-lg-12">
                <div style="margin-top: 10px;margin-bottom: 10px;"><strong>Selectioner un Icon:</strong></div>
                
                  <!-- Iterate over icons array -->
                  <span class="col-lg-3" *ngFor="let icon of icons" style="margin: 10px;padding: 10px;">
                   
                      <!-- Display mat-icon -->
                      <span style="margin-right: 5px;"> <mat-icon mat-list-icon  [svgIcon]="icon"></mat-icon></span> 
                      <!-- Radio button -->
                      <input type="radio" name="icon" [value]="icon" [(ngModel)]="menuObj.icon"  [disabled]="lecture" [ngClass]="{ 'non-editable': lecture }">
                      <span class="checkmark"></span>
                   
                  </span>
                  <!-- Option for "pas un icon" -->
                  <label class="radio-container">Pas un icon
                    <input type="radio" name="icon" value="pas un icon" [(ngModel)]="menuObj.icon" [disabled]="lecture" [ngClass]="{ 'non-editable': lecture }">
                    <span class="checkmark"></span>
                  </label>
                
              </div>
            </div>
          </div>
          
        </div>

      </ng-container>

    </div>

  </div>
</div>